<template>
  <v-card>
    <v-card-title class="primary white--text headline">
      <span>{{this.$t('downloadCSV')}}</span>
      <v-spacer/>
      <Icon
      @icon-clicked="$emit('close-csv-export')"
      :tooltipText="$t('close')"
      dataTestId="close-csv-export-button"
      iconColor="white"
      icon="mdi-close"
      :small="false"
      :large="true"
      />
    </v-card-title>
    <v-card-text>
      <v-container
        class="px-0"
        fluid
      >
        <v-radio-group v-model="chosenOption">
          <v-radio
            v-for="option in options"
            :key="option.value"
            color="primary"
            :label="option.label"
            :value="option.value"
          ></v-radio>
        </v-radio-group>
        <span v-if="downloadUnavailable" class="error--text">{{$t('settlementCsvUnavailable')}}</span>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <Icon
      v-if="downloadUnavailable"
      :tooltipText="$t('refresh')"
      :small="false"
      iconColor="black"
      icon="mdi-refresh"
      @icon-clicked="refreshExportBatch"
      />
      <v-spacer/>
      <v-btn class="primary mr-n4 mb-2" @click="exportCSV" :disabled="downloadUnavailable">
        {{this.$t('download')}}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { SettlementCsvExportType } from '@/utils/Enumerations'

export default {
  name: 'CSVExport',

  components: {
    Icon: () => import('@/components/helper/Icon.vue')
  },

  props: {
    isByProducts: {
      type: Boolean,
      required: true
    },
    isAdjustingEntries: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    chosenOption: SettlementCsvExportType.AccountsPayable.value,
    exportBatch: null
  }),

  computed: {
    ...mapGetters('settlements', ['dateConfiguration']),

    options () {
      return SettlementCsvExportType.enums.map(exportType => ({
        value: exportType.value,
        label: exportType.name
      }))
    },

    downloadUnavailable () {
      return !this.isAdjustingEntries && this.exportBatch?.exportsSavedOn === null
    }
  },

  created () {
    if (!this.isAdjustingEntries) {
      this.refreshExportBatch()
    }
  },

  methods: {
    ...mapActions('settlements', ['fetchSettlementCSV']),
    ...mapActions('export-batch', ['fetchExportBatchById']),

    async refreshExportBatch () {
      this.exportBatch = await this.fetchExportBatchById(this.dateConfiguration.exportBatch)
    },

    async exportCSV () {
      if (this.isAdjustingEntries) {
        this.$emit('downloadCsv', this.chosenOption)
        return
      }

      if (this.downloadUnavailable) {
        return
      }

      const selectedType = SettlementCsvExportType.forInt(this.chosenOption)

      if (selectedType === SettlementCsvExportType.All) {
        await this.fetchAllExports()
        return
      }

      const requestObj = {
        ...this.dateConfiguration,
        isByproduct: this.isByProducts,
        type: selectedType.details.requestType
      }

      this.fetchSettlementCSV(requestObj)
    },

    async fetchAllExports () {
      const requestObj = {
        ...this.dateConfiguration,
        isByproduct: this.isByProducts
      }

      const exportTypes = [
        SettlementCsvExportType.AccountsPayable,
        SettlementCsvExportType.AccountsReceivable,
        SettlementCsvExportType.Accruals,
        SettlementCsvExportType.StatisticalJournals
      ]

      for (const exportType of exportTypes) {
        requestObj.type = exportType.details.requestType
        await this.fetchSettlementCSV(requestObj)
      }
    }
  }
}
</script>
